module.exports = __webpack_public_path__ + "static/media/mouse-scroll.c717f33b.svg";